export default function togglePasswordInputEye() {
  function findNearestPasswordInput(element) {
    while (element) {
      // eslint-disable-next-line no-param-reassign
      element = element.parentElement;
      if (element && element.querySelector && element.querySelector("input")) {
        return element.querySelector("input");
      }
    }
    return null;
  }

  function togglePasswordVisibility(input, addon) {
    if (input.type === "password") {
      // eslint-disable-next-line no-param-reassign
      input.type = "text";
      addon.querySelector(".icon").setAttribute("class", "icon icon--eye-off");
      addon.querySelector("use").setAttribute("xlink:href", "/assets/media/icons/symbol-defs.svg#icon-eye-off");
    } else {
      // eslint-disable-next-line no-param-reassign
      input.type = "password";
      addon.querySelector(".icon").setAttribute("class", "icon icon--eye");
      addon.querySelector("use").setAttribute("xlink:href", "/assets/media/icons/symbol-defs.svg#icon-eye");
    }
  }

  const shrAddons = document.querySelectorAll(".addon-password-icon");

  shrAddons.forEach((addon) => {
    addon.addEventListener("click", () => {
      const input = findNearestPasswordInput(addon);

      if (input && !input.disabled && !input.readOnly) {
        togglePasswordVisibility(input, addon);
      }
    });

    addon.addEventListener("mouseenter", () => {
      // eslint-disable-next-line no-param-reassign
      addon.style.color = "#00A5B5";
      // eslint-disable-next-line no-param-reassign
      addon.style.borderColor = "#00A5B5";

      const input = findNearestPasswordInput(addon);

      if (input && !input.disabled && !input.readOnly) {
        input.style.borderColor = "#00A5B5";
      }
    });

    addon.addEventListener("mouseleave", () => {
      // eslint-disable-next-line no-param-reassign
      addon.style.color = "#404245";
      // eslint-disable-next-line no-param-reassign
      addon.style.borderColor = "#B9B9BB";

      const input = findNearestPasswordInput(addon);

      if (input && !input.disabled && !input.readOnly) {
        input.style.borderColor = "#B9B9BB";
      }

      if (input.classList.contains("add-error")) {
        input.style.borderColor = "#db323b";

        // eslint-disable-next-line no-param-reassign
        addon.style.borderLeftColor = "#db323b";
      }
    });
  });
}
